module.exports = __webpack_public_path__ + "static/media/star-exercise.7539d935.png";